import { module } from 'modujs';
import { SplitText } from "gsap/SplitText.js";

gsap.registerPlugin(SplitText);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        gsap.delayedCall(0.6, () => {
            const splittedTitle = new SplitText(this.el, { type: this.getData('type') !== null ? this.getData('type') : 'lines' });

            const lines = this.el.querySelectorAll('div');

            for (let i = 0; i < lines.length; i++) {
                const line = lines[i];
                const lineInner = line.innerHTML;

                line.innerHTML = '<div></div>'

                line.querySelector('div').innerHTML = lineInner;

            }

            this.el.classList.add('is-split');

            this.callback();
        });
    }

    // Do not remove, used in `ProjectListHeading`
    callback() {}
}
